module.exports = "/_next/static/images/a91504d8e1fa0a87b54e4042daf60d05-man-with-cellphone-xs@3x.jpg.webp";